import { Component } from "react";
import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { NWSRegionLayout } from "../NWSRegionLayout";

class HomePage extends Component<NSARouterMakerResult>
{
    override render()
    {
        return (
            <NWSRegionLayout {...this.props}>
                <NSAHomePage {...this.props} />
            </NWSRegionLayout>
        );
    }
}

export default HomePage;